import React from "react";

function DashboardWrap({children}: any) {
  return (
    <div className="h-100 cnd-menu-offset">{children}</div>
  );
}

export default DashboardWrap;
